import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import { compatWrapper } from '@backstage/core-compat-api';
import { ErrorPanel } from '@backstage/core-components';
import {
  type ErrorDisplayProps,
  ErrorDisplay as ErrorDisplayRef,
} from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';
import { Button } from '@backstage/ui';

export const SentryErrorDisplay = ({
  plugin,
  error,
  resetError,
}: ErrorDisplayProps) => {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: { plugin: plugin?.id },
    });
  }, [error, plugin]);

  return (
    <ErrorPanel title={`Error in ${plugin?.id}`} error={error} defaultExpanded>
      <Button variant="secondary" onPress={resetError}>
        Retry
      </Button>
    </ErrorPanel>
  );
};

export const ErrorDisplay = SwappableComponentBlueprint.make({
  name: 'core-error-display',
  params: define =>
    define({
      component: ErrorDisplayRef,
      loader: () => props => compatWrapper(<SentryErrorDisplay {...props} />),
    }),
});
